<template>
  <div>
    <div class="header">
      <div class="row border-bottom">
        <nav class="navbar navbar-static-top gray-bg" role="navigation" style="margin-bottom: 0">
          <div class="navbar-header">
            <a class="navbar-minimalize minimalize-styl-2 btn btn-primary" @click="onCollapseMenu">
              <i class="fa fa-bars"></i>
            </a>
            <form role="search" class="navbar-form-custom" v-on:submit.prevent="onSearch">
              <div class="form-group">
                <input
                  type="text"
                  v-model="searchTerm"
                  placeholder="Search interactions..."
                  class="form-control"
                  name="top-search"
                  id="top-search"
                />
              </div>
            </form>
          </div>
          <ul class="nav navbar-top-links navbar-right">
            <li>
              <span class="m-r-sm text-muted welcome-message">
                <span v-if="!me.is_staff && !me.is_admin && !me.is_org_admin">{{ me.company_name }}</span>
                <span v-if="me.is_staff || me.is_admin || me.is_org_admin">
                  <a
                    @click="selectCompanyDialogVisible=!selectCompanyDialogVisible"
                  >{{ me.company_name }}</a>
                </span>
              </span>
              <span
                v-if="me.is_streaming"
                :class="`label label-${getStreamingStats().streamingClass}`"
              >
                Streaming: {{ getStreamingStats().now }}
                <i
                  :class="`fa fa-level-${getStreamingStats().growthClass}`"
                  v-if="getStreamingStats().growth !== 0"
                >{{ getStreamingStats().growth }}</i>
              </span>
            </li>
             <li class="header-item">
                <el-tooltip content="Knowledge Base" placement="bottom">
                  <el-button size="mini" @click="handleKnowledgeBaseClick">
                    <i class="fa fa-lightbulb-o"></i>
                  </el-button>
                </el-tooltip>
              </li>

            <li class="header-item">
              <el-tooltip content="New Social Post" placement="bottom">
                <el-button size="mini" @click="handleNewSocialPost">
                  <i class="fa fa-share-alt"></i>
                </el-button>
              </el-tooltip>

              <!-- <el-dropdown
                @click="handleNewSocialPost"
                :show-timeout="150"
                :hide-timeout="150"
                size="mini"
                split-button>
                <el-tooltip content="Social Post" placement="bottom">
                  <span class="fa fa-share-alt"></span>
                </el-tooltip>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="scheduledPosts.length === 0" :disabled="true">
                    No scheduled posts
                  </el-dropdown-item>
                  <el-dropdown-item v-for="post in scheduledPosts" :key="post.id">
                    {{post}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
            </li>

            <li class="header-item">
              <el-tooltip effect="dark" content="Support">
                <el-button size="mini" @click="handleHelpClick" plain>
                  <i class="fa fa-question"></i>
                </el-button>
              </el-tooltip>
            </li>

            <li class="header-item">
              <el-dropdown :hide-on-click="false" trigger="hover" placement="bottom">
                <el-badge :value="activities.length" class="activity-badge">
                  <el-button size="mini" plain>
                    <i class="fa fa-bell"></i>
                    <b class="caret"></b>
                  </el-button>
                </el-badge>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item id="item">
                    <activities-list :activities="activities" @deleteActivity="deleteActivity"></activities-list>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
            <li class="spacing">
              <el-dropdown
                trigger="hover"
                placement="bottom"
                :show-timeout="100"
                @command="handleDropdownCommand"
              >
                <span class="el-dropdown-link">
                  <img
                    class="img-circle"
                    :src="user.avatar || user.gravatar"
                    width="32px"
                    :size="32"
                  />
                  <b class="caret"></b>
                </span>
                <el-dropdown-menu id="user-dropdown" slot="dropdown" :ref="'userdropdown'">
                  <el-dropdown-item command="editProfileDialogVisible">
                    <span class="fa fa-user"></span>&nbsp;Edit Profile
                  </el-dropdown-item>
                  <el-dropdown-item command="restPasswordDialogVisible">
                    <span class="fa fa-key"></span>Change Password
                  </el-dropdown-item>
                  <el-dropdown-item command="onLogout" :divided="true">
                    <span class="fa fa-sign-out"></span>Log out
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>
        </nav>
      </div>
      <div class="row wrapper border-bottom white-bg page-heading" v-if="dashboardHeaderEnabled">
        <div class="col-lg-10">
          <h2>{{ dashboardTitle }}</h2>
          <ol class="breadcrumb">
            <li v-for="breadcrumb in breadcrumbs" v-bind:key="breadcrumb">{{ breadcrumb }}</li>
          </ol>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="restPasswordDialogVisible"
      title="Change Password"
      :visible.sync="restPasswordDialogVisible"
      :append-to-body="true"
    >
      <PasswordOnlyResetForm
        v-on:togglePasswordDialog="handleToggleDialog"
        :requireOldPassword="true"
      ></PasswordOnlyResetForm>
    </el-dialog>

    <el-dialog title="Edit Profile" :visible.sync="editProfileDialogVisible" :append-to-body="true">
      <edit-profile-form :user="user"></edit-profile-form>
    </el-dialog>

    <el-dialog title="Select Company" :visible.sync="selectCompanyDialogVisible">
      <company-selector @onSwitchCompany="onSwitchCompany($event)" :companies="companies"></company-selector>
    </el-dialog>
  </div>
</template>

<script>
/* eslint consistent-return: "off" */
import gql from 'graphql-tag';
import CompanySelector from '@/components/company/CompanySelector';
import Password from 'vue-password-strength-meter';
import ActivitiesList from '@/components/activities/ActivitiesList';
import { mapState } from 'vuex';
import EditProfileForm from '@/components/user/EditProfileForm';
import PasswordOnlyResetForm from '@/components/auth/PasswordOnlyResetForm';
import * as analyticsTypes from '@/store/modules/analytics/mutation-types';

export default {
  name: 'AppHeader',

  apollo: {
    $client: 'apiv2',
    $subscribe: {
      onLiveStatsUpdated: {
        query: gql`
          subscription {
            streaming {
              live_streams
            }
          }
        `,
        result(data) {
          this.nowLiveStreamingStates = data.data.streaming;
          this.prevLiveStreamingStates = this.$store.state.analytics.liveStreamingStates;
          this.$store.commit(
            `analytics/${analyticsTypes.SET_ANALYTICS_LIVE_STREAM_STATS}`,
            this.nowLiveStreamingStates,
          );
        },
      },
    },
  },

  components: {
    CompanySelector,
    Password,
    ActivitiesList,
    EditProfileForm,
    PasswordOnlyResetForm,
  },
  data: () => ({
    selectCompanyDialogVisible: false,
    restPasswordDialogVisible: false,
    showActivities: false,
    searchTerm: '',
    newPassword: null,
    confrimedPassword: null,

    showUserMenu: false,
    editProfileDialogVisible: false,
    showSubmenuTimeout: 150,
    prevLiveStreamingStates: { live_streams: 0 },
    nowLiveStreamingStates: { live_streams: 0 },
  }),
  props: {
    isPending: {
      type: Boolean,
      default: false,
    },
    me: {
      type: Object,
      required: true,
    },
    activities: {
      type: Array,
      default: () => [{}, {}],
    },
    companies: {
      type: Array,
      required: true,
    },
    breadCrumbs: {
      type: Array,
      default: () => [],
    },
    dashboardTitle: {
      type: String,
      default: '',
    },
    dashboardHeaderEnabled: {
      type: Boolean,
      default: false,
    },
    scheduledPosts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isDisabled() {
      return this.newPassword !== this.confirmedPassword;
    },

    user() {
      return this.me;
    },

    ...mapState(['sidebarCollapsed']),
    ...mapState('auth', ['passwordResetFailed']),
  },
  watch: {
    passwordResetFailed(val) {
      if (val && !this.restPasswordDialogVisible) {
        this.restPasswordDialogVisible = true;
      }
    },
  },
  methods: {
    handleToggleDialog() {
      this.restPasswordDialogVisible = !this.restPasswordDialogVisible;
    },
    handleHelpClick() {
      window.open('mailto:support@colonyhq.com?subject=Colony%20Live%20Support%20Request');
    },

    handleKnowledgeBaseClick() {
      window.open('https://colonylive.com/knowledgebase/', '_blank');
    },

    getStreamingStats() {
      const live = this.nowLiveStreamingStates.live_streams;
      const prevLive = this.prevLiveStreamingStates.live_streams;
      const liveGrowth = live - prevLive;
      const labelClass = liveGrowth >= 0 ? 'success' : 'danger';
      const arrowClass = liveGrowth >= 0 ? 'up' : 'down';
      return {
        now: live,
        growth: liveGrowth,
        streamingClass: labelClass,
        growthClass: arrowClass,
      };
    },

    onSearch() {
      this.$emit('onSearch', { searchTerm: this.searchTerm });
    },

    onCollapseMenu() {
      this.$emit('onCollapseMenu');
    },

    onLogout() {
      this.$emit('onLogout');
    },

    onSwitchCompany(event) {
      const payload = {
        company: event.company,
        user: this.$store.state.user.me.id,
      };
      this.$store.dispatch('user/updateUserCompany', payload);
    },
    onResetPassword() {
      const payload = {
        password: this.confrimPassword,
        user: this.$store.state.user.me.id,
      };
      this.$store.dispatch('user/updatePassword', payload);
    },

    deleteActivity(id) {
      this.$store.dispatch('activities/deleteActivity', id);
    },

    handleNewSocialPost() {
      this.$emit('onNewSocialPost');
    },
    handleDropdownCommand(cmd) {
      if (cmd === 'onLogout') return this.onLogout();
      this[cmd] = !this[cmd];
    },
  },
  beforeDestroy() {
    this.$store.dispatch('activities/stopActivityPolling');
  },
  mounted() {
    /*
    for some reason the dropdown popper did not show/hide the first time it was
    triggered. This emulates the initial non-working trigger of show and hide.
    Thereafter it works as expected. It's ugly, but it works.
    */
    this.$refs.userdropdown.createPopper();
    this.$refs.userdropdown.dropdown.show();
    setTimeout(this.$refs.userdropdown.dropdown.hide, 100);
  },
};
</script>

<style lang="scss" >
.header-item {
  margin: 12px auto;
}

.activity-badge {
  margin-top: -2px;
}

.colony-badge {
  font-size: 14px;
  cursor: help;

  sup {
    font-size: 60%;
    margin-left: 3px;
  }
}

.hint {
  font-size: 10px;
  padding: 2px;
  color: gray;
}

.password-field .Password {
  max-width: 100%;
  margin: 0 auto;
}

.password-field .Password__field {
  border-radius: 2px;
  box-sizing: border-box;
  font-size: 14px;
  padding: 5px;
  width: 100%;
}

.password-field .Password__badge {
  float: right;
  position: relative;
  bottom: 33px;
  right: 8px;
  color: #fff;
  border-radius: 3px;
  padding: 3px;
  width: 20px;
  height: 20px;
  font-size: 10px;
  line-height: 1.1;
  text-align: center;
}

#item:hover {
  background-color: #fff;
}
.spacing {
  padding-left: 1.2em;
}
</style>



// WEBPACK FOOTER //
// AppHeader.vue?66b61c24